import { createClient } from '@supabase/supabase-js';
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Carousel } from 'react-bootstrap';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import { getUserDisplayName, isValidDisplayName } from '../utils/profile';


const supabase = createClient(process.env.REACT_APP_SUPABASE_URL, process.env.REACT_APP_SUPABASE_API_KEY);

function AppAuth() {
  const [session, setSession] = useState(null);
  const [authMode, setAuthMode] = useState('sign_in');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [displayName, setDisplayName] = useState('');
  const [message, setMessage] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    supabase.auth.getSession().then(({ data: { session } }) => {
      setSession(session)
    })
    const {
      data: { subscription },
    } = supabase.auth.onAuthStateChange((_event, session) => {
      setSession(session)
    })
    return () => subscription.unsubscribe()
  }, [])

  async function handleAuthSubmit(event) {
    event.preventDefault();
    setMessage('');
    setErrorMessage('');

    if (authMode === 'sign_up') {
      const name = displayName.trim();
      if (!isValidDisplayName(name)) {
        setErrorMessage('Choose a display name between 2 and 32 characters. Do not use an email address.');
        return;
      }
    }

    setIsSubmitting(true);
    try {
      if (authMode === 'reset_password') {
        const { error } = await supabase.auth.resetPasswordForEmail(email, {
          redirectTo: `${window.location.origin}/settings`,
        });
        if (error) throw error;
        setMessage('Check your email for a password reset link.');
      } else if (authMode === 'sign_up') {
        const { data, error } = await supabase.auth.signUp({
          email,
          password,
          options: { data: { display_name: displayName.trim() } },
        });
        if (error) throw error;
        if (data.session) {
          setSession(data.session);
        } else {
          setMessage('Check your email to confirm your account. Your display name is saved with your account.');
        }
      } else {
        const { data, error } = await supabase.auth.signInWithPassword({ email, password });
        if (error) throw error;
        setSession(data.session);
      }
    } catch (error) {
      setErrorMessage(error.message || 'Authentication failed. Please try again.');
    } finally {
      setIsSubmitting(false);
    }
  }

    if(!session) {
      return (
        <section className="auth-form">
          <div className="auth-mode-switch" role="group" aria-label="Account access">
            <Button
              type="button"
              variant={authMode === 'sign_in' ? 'primary' : 'light'}
              aria-pressed={authMode === 'sign_in'}
              onClick={() => { setAuthMode('sign_in'); setMessage(''); setErrorMessage(''); }}
            >Sign in</Button>
            <Button
              type="button"
              variant={authMode === 'sign_up' ? 'primary' : 'light'}
              aria-pressed={authMode === 'sign_up'}
              onClick={() => { setAuthMode('sign_up'); setMessage(''); setErrorMessage(''); }}
            >Create account</Button>
          </div>
          <Form onSubmit={handleAuthSubmit}>
            {authMode === 'sign_up' && (
              <Form.Group className="mb-3" controlId="signupDisplayName">
                <Form.Label>Public display name</Form.Label>
                <Form.Control
                  type="text"
                  minLength={2}
                  maxLength={32}
                  autoComplete="nickname"
                  required
                  value={displayName}
                  onChange={(event) => setDisplayName(event.target.value)}
                  placeholder="How readers will know you"
                />
                <Form.Text>This name appears on your posts. Your email stays private.</Form.Text>
              </Form.Group>
            )}
            <Form.Group className="mb-3" controlId="authEmail">
              <Form.Label>Email address</Form.Label>
              <Form.Control
                type="email"
                autoComplete="email"
                required
                value={email}
                onChange={(event) => setEmail(event.target.value)}
                placeholder="you@example.com"
              />
            </Form.Group>
            {authMode !== 'reset_password' && (
              <Form.Group className="mb-3" controlId="authPassword">
                <Form.Label>Password</Form.Label>
                <Form.Control
                  type="password"
                  autoComplete={authMode === 'sign_up' ? 'new-password' : 'current-password'}
                  minLength={6}
                  required
                  value={password}
                  onChange={(event) => setPassword(event.target.value)}
                  placeholder={authMode === 'sign_up' ? 'At least 6 characters' : 'Your password'}
                />
              </Form.Group>
            )}
            {errorMessage && <p className="auth-message auth-error" role="alert">{errorMessage}</p>}
            {message && <p className="auth-message auth-success" role="status">{message}</p>}
            <Button className="w-100" type="submit" disabled={isSubmitting}>
              {isSubmitting ? 'Please wait...' : authMode === 'sign_up' ? 'Create account' : authMode === 'reset_password' ? 'Send reset link' : 'Sign in'}
            </Button>
          </Form>
          <div className="auth-secondary-actions">
            {authMode === 'sign_in' && (
              <Button variant="link" type="button" onClick={() => { setAuthMode('reset_password'); setMessage(''); setErrorMessage(''); }}>
                Forgot password?
              </Button>
            )}
            {authMode === 'reset_password' && (
              <Button variant="link" type="button" onClick={() => { setAuthMode('sign_in'); setMessage(''); setErrorMessage(''); }}>
                Back to sign in
              </Button>
            )}
          </div>
        </section>
      );
    }else{
        return(
            <>
            <div className='container justify-content-center text-center'>
                <h1>Welcome {getUserDisplayName(session.user)}</h1>
                <h3>What would you like to do today?</h3>

                

                <Carousel>
      <Carousel.Item>
        <img alt="A quiet writing desk" src='https://images.pexels.com/photos/2950003/pexels-photo-2950003.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1'/>

        <Carousel.Caption>
        <Link id='homeLink' to={'/'}>Home</Link>
          <p>Go to home page to see other peoples blogs!</p>
        </Carousel.Caption>
      </Carousel.Item>
      <Carousel.Item>
      <img alt="An open notebook ready for a new post" src='https://images.pexels.com/photos/1539581/pexels-photo-1539581.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1'/>

        <Carousel.Caption>
            <Link id='createLink' to={'/create'} >Create a Blog!</Link>
          <p>Create a new blog and share something great with the World!</p>
        </Carousel.Caption>
      </Carousel.Item>
      <Carousel.Item>
      <img alt="Books and notes on a desk" src='https://images.pexels.com/photos/2882509/pexels-photo-2882509.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1'/>
        <Carousel.Caption>
        <Link id='aboutLink' to={'/about'} >About</Link>
          <p>
            Go to the about page to learn more about us!
          </p>
        </Carousel.Caption>
      </Carousel.Item>
      <Carousel.Item>
      <img alt="A person writing in a notebook" src='https://images.pexels.com/photos/5697262/pexels-photo-5697262.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1'/>
        <Carousel.Caption>
        <Link id='supportLink' to={'/support'}>Support</Link>
          <p>
            Go to the support page to contact us!
          </p>
        </Carousel.Caption>
      </Carousel.Item>
      <Carousel.Item>
      <img alt="A welcoming community space" src='https://images.pexels.com/photos/134065/pexels-photo-134065.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1'/>
        <Carousel.Caption>
        <button id='logoutButton' onClick={async () => {
                        await supabase.auth.signOut()
                        }}>Sign Out</button>
          <p id='logoutText'>
            Hope to see you soon!
          </p>
        </Carousel.Caption>
      </Carousel.Item>
    </Carousel>

               
               
              
            </div>
            </>
        );
        
    
    }
  
}

export default AppAuth;
export {supabase};
